import './phone-placeholder.scss'

import _ from 'lodash'
import 'intl-tel-input/build/js/intlTelInput'
import 'intl-tel-input/build/js/utils'
import 'jquery-mask-plugin'

export default class {
  constructor(input) {
    this.input = input

    this.nationalMode = false
    this.countries = [
      'ru',
      'ua',
      'kz',
      'uz',
      'by',
      'pl',
      'de',
      'az',
      'us',
      'kg',
      'tj',
      'ge',
      'am',
      'bg',
      'lt',
      'md',
      'rs',
      'sk',
      'mn',
      'il',
      'tm',
      'lv',
      'ee',
      'cz'
    ]

    this.input.intlTelInput({
      defaultCountry: 'ru',
      preferredCountries: this.countries,
      autoPlaceholder: 'aggressive',
      autoHideDialCode: true,
      nationalMode: this.nationalMode
    })
    this.input.intlTelInput('handleUtils')

    this.setMask()

    this.input.on('countrychange', () => this.setMask())
  }

  setMask() {
    let countryData = this.input.intlTelInput('getSelectedCountryData')
    let countryCode = countryData.iso2
    let numberType = window.intlTelInputUtils.numberType['MOBILE']
    let example = window.intlTelInputUtils.getExampleNumber(
      countryCode,
      this.nationalMode,
      numberType
    )
    let dialCode = countryData.dialCode
    let mask = null
    let formattedDial = null
    if (countryCode) {
      mask = example.replace(/[0-9]/g, 'd')
      _.each(dialCode.split(''), (dialCodeDigit) => {
        mask = mask.replace('d', dialCodeDigit)
      })
      formattedDial = mask.substr(0, mask.indexOf(_.last(dialCode)) + 1)
    } else {
      mask = '+' + _.repeat('d', 12)
      formattedDial = '+'
    }

    this.input.mask(mask, {
      translation: { d: { pattern: /\d/ } },
      onKeyPress: (val, _e, field) => {
        if (val.length < formattedDial.length) {
          field.val(formattedDial)
        }
      }
    })
  }
}
